export default __webpack_public_path__ + "static/media/Transmission.c3ce5fa6.svg";